/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageChannelRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageChannel/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
